import { ActionType, getType } from 'typesafe-actions';
import * as actions from './actions';
import { IWizardSession } from './types';

const INITIAL_STATE: IWizardSession = {
  isStarted: false,
};

type WizardSessionActions = ActionType<typeof actions>;

function reducer(
  state: IWizardSession = INITIAL_STATE,
  action: WizardSessionActions,
): IWizardSession {
  switch (action.type) {
    case getType(actions.startWizardSession):
      return {
        ...state,
        isStarted: true,
      };
    default:
      return state;
  }
}

export default reducer;
export type { IWizardSession };
